import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Settings, PlayCircle, BarChart3, LogOut, Webhook, Link as LinkIcon, Megaphone, Newspaper, Trophy, Crown, DollarSign, Gift, CalendarClock, Scissors, ExternalLink, UserCog } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_87cd0f70-4f18-4348-a2fd-e2666a61734d/artifacts/ozrawt0t_IMG_0439.jpeg';

// `route` field, when set, navigates to that path instead of changing the
// active tab — useful for full-screen standalone admin pages.
const TABS = [
  { key: 'settings', label: 'Settings', icon: Settings },
  { key: 'videos', label: 'Videos', icon: PlayCircle },
  { key: 'wins', label: 'Wins', icon: Trophy },
  { key: 'elite', label: 'Elite Network', icon: Crown },
  { key: 'analytics', label: 'Analytics', icon: BarChart3 },
  { key: 'broker', label: 'Broker', icon: Webhook },
  { key: 'cpa', label: 'CPA', icon: DollarSign },
  { key: 'giveaways', label: 'Giveaways', icon: Gift },
  { key: 'bookings', label: 'Bookings', icon: CalendarClock },
  { key: 'clippers', label: 'Clippers', icon: Scissors },
  { key: 'staff', label: 'Staff', icon: UserCog },
  { key: 'ads', label: 'Ads', icon: Megaphone },
  { key: 'blog', label: 'Blog', icon: Newspaper },
  { key: 'shortlinks', label: 'Links', icon: LinkIcon },
];

export default function AdminSidebar({ tab, setTab, email, onLogout }) {
  const navigate = useNavigate();
  return (
    <aside className="w-60 shrink-0 min-h-screen hidden md:flex flex-col bg-[hsl(240_6%_7%)] border-r border-border">
      <div className="px-4 py-4 flex items-center gap-2 border-b border-border">
        <img src={LOGO} alt="AlveeTrade" className="h-9 w-9 rounded-lg gold-hairline" />
        <div>
          <div className="font-display uppercase text-lg tracking-wide leading-none">AlveeTrade</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[hsl(43_92%_56%)] mt-1">Admin</div>
        </div>
      </div>
      <nav className="p-3 space-y-1">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => {
              if (t.route) { navigate(t.route); return; }
              setTab(t.key);
            }}
            data-testid={`admin-tab-${t.key}`}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${tab === t.key && !t.route ? 'bg-[rgba(245,185,66,0.10)] text-[hsl(43_92%_56%)] border border-[rgba(245,185,66,0.28)]' : 'text-muted-foreground hover:text-white hover:bg-[hsl(240_6%_10%)]'}`}
          >
            <t.icon className="h-4 w-4" /> <span className="flex-1 text-left">{t.label}</span>
            {t.external && <ExternalLink className="h-3 w-3 opacity-50" />}
          </button>
        ))}
      </nav>
      <div className="mt-auto p-3 border-t border-border">
        <div className="text-xs text-muted-foreground mb-2 truncate">{email}</div>
        <Button variant="outline" onClick={onLogout} className="w-full gap-2 border-border" data-testid="admin-logout-button">
          <LogOut className="h-4 w-4" /> Logout
        </Button>
      </div>
    </aside>
  );
}
